<!-- 利用規約画面 -->

<template>
  <div class="agreement">

    <div class="agreement-title" v-html="$t('tos.title')"></div>

    <div class="agreement-colum">
      <div class="agreement-colum-text">
        本規約は、ライオン株式会社（以下、「当社」といいます）が提供する「口腔機能チェックWEBアプリケーションβ版サービス（以下、「本サービス」といい、具体的な内容は第1条の定義に従います）に関するものです。医療機関が本サービスを利用（本サービス向上のためのテスト実施のための利用も含みます）するには、本利用規約の内容に同意し、当社指定の方法に従い、所定の情報を入力したうえで登録を完了する必要があります。登録が完了した医療機関のみが、このサービスを利用することができます。      
      </div>
    </div>

    <div class="agreement-colum">
      <div class="agreement-colum-title">第1条（定義）</div>
      <div class="agreement-colum-text">
        本規約で使用する用語の定義は、次に掲げるとおりとします。<br/><br/>

        （1）本サービス<br/>
        口腔機能チェックWEBアプリケーションβ版サービス<br/><br/>
        【主なサービス内容】<br/>
        ・オーラルディアドコキネシスの測定<br/>
        ・OF-5（Oral frailty 5-item Checklist）を用いたオーラルフレイルのチェック<br/>
        ・上記に対する結果レポートの表示（デバイス連携済みプリンタにて印刷が可能）<br/>
        ・本サービスのご利用は無料です。ただし、インターネットに接続するための通信費用は登録医療機関の負担となります。<br/>
        ・本サービスを利用できる時間は、午前7時から午後10時となります。土日祝日は問いません。<br/><br/>
        <br/>

        （2）登録医療機関<br/>
        本サービスの利用を当社に申請し、当社に本サービスの利用が認められ、当社からその旨の通知を受けた医療機関。医療機関とは、歯科医院、大学付属病院、企業付属診療所などを指します（その他、当社が特に認めた個人、団体を含みます）。<br/><br/>

        （3）利用者<br/>
        登録医療機関にお勤めの歯科医療従事者の方（歯科医師、歯科衛生士など）であり、登録医療機関が利用を認めた方を指します（その他、当社が特に認めた個人を含みます）。<br/><br/>

        （4）来院者等<br/>
        登録医療機関で本サービスを受ける受診者の方（その他、当社が提供するサービスの品質向上のためのテストのために当該サービスを受ける方も含む）<br/><br/>
        
      </div>
    </div>

    <div class="agreement-colum">
      <div class="agreement-colum-title">第2条（申込み方法等）</div>
      <div class="agreement-colum-text">
        1.	本サービスを利用するためには、当社の運営するサイトに設置された申込フォームや申込書、契約書など当社の所定する方法によって申込みを行い、登録医療機関としての登録を行う必要があります。<br/><br/>
        2.	利用者は、前項に定める登録医療機関としての登録が完了した日以降、当社が定める期間、本サービスをご利用いただくことができます。<br/><br/>
      </div>
    </div>

    <div class="agreement-colum">
      <div class="agreement-colum-title">第3条（本規約の範囲及び変更）</div>
      <div class="agreement-colum-text">
        1.	本規約は、登録医療機関および利用者による本サービスの利用について定めるもので、登録医療機関は誠実に本規約を遵守するとともに、利用者にも遵守させるものとし、利用者の行為に対し、登録医療機関は責任を負うこととします。<br/><br/>
        2.	本規約は「<a href="https://www.lion.co.jp/ja/legal/tou.php" target="_blank">ライオン グループ ウェブサイト・ソーシャルメディア利用規約</a>」
        （以下、ウェブサイト・ソーシャルメディア利用規約）、及びライオン「<a href="https://www.lion.co.jp/ja/legal/privacy/protect.php" target="_blank">個人情報の取り扱いについて</a>」に準拠していますので、あわせてご確認下さい。<br/><br/>
        3.	当社は、登録医療機関への事前の通知および同意の取得を要することなく本規約の内容の一部または全部を変更することができるものとします。この場合、変更後の本規約が適用されるものとします。<br/><br/>
      </div>
    </div>

    <div class="agreement-colum">
      <div class="agreement-colum-title">第4条（登録）</div>
      <div class="agreement-colum-text">
        1.	登録医療機関は、第２条に基づく申込みを行った時点で、本規約に同意したものとみなされるものとします。<br/><br/>
        2.	登録医療機関が本規約に違反した場合（利用者が本規約に違反した場合も含む）、利用者が登録医療機関登録後に当該登録医療機関にお勤めの歯科医療従事者ではなくなった場合、または特別の事情により当社が必要と判断した場合は、本サービスの利用をお断りすることがあります。<br/><br/>
        3.	当社は、登録希望者が以下の項目に該当する場合、特定の利用者の本サービスの利用をお断りする場合があります。<br/>
        (1) 登録希望者が、過去に本規約違反等により、利用者資格の取消が行われている場合<br/>
        (2) その他、当社が登録を行うのに不適切と判断した場合<br/><br/>
        4．登録または登録の拒否に関連して、登録医療機関または利用者に何らかの損害が生じたとしても、当社は一切責任を負わないものとします。<br/><br/>
      </div>
    </div>

    <div class="agreement-colum">
      <div class="agreement-colum-title">第5条（アカウントの管理）</div>
      <div class="agreement-colum-text">
        1.	当社は、本サービスを利用するために必要となるID及びパスワード（以下「ID等」という）を登録医療機関に付与します。登録医療機関は、ID等を第三者に貸与し、譲渡し、使用させ（登録医療機関に所属する利用者に使用させる場合は除く）または処分してはならないものとします。<br/><br/>
        2.	登録医療機関は、ID等について、善良なる管理者の注意をもって厳重に管理、保管するものとします。当社は、登録医療機関が付与したID等を使用して本サービスが利用された場合は、登録医療機関または利用者による利用とみなすものとし、ID等の盗用、不正使用その他、登録医療機関、利用者以外の第三者による利用であっても、当該利用に起因して登録医療機関、利用者または第三者に生じる損害および結果について、損害賠償責任その他一切の責任を負わないものとします。<br/><br/>
      </div>
    </div>

    <div class="agreement-colum">
      <div class="agreement-colum-title">第6条（禁止事項） </div>
      <div class="agreement-colum-text">
        1.	当社は、登録医療機関および利用者による本サービスの利用に際して、以下の各号に定める行為を禁止します。当社において、登録医療機関または利用者が禁止事項に違反したと認めた場合、事前に通知することなく、直ちに本サービスの利用停止、当該医療機関に付与したID等の削除、その他当社において必要と判断した措置を取ることができるものとし、登録医療機関はこれに異議なく同意するものとします。<br/>
        (1)	当社または第三者の知的財産権を侵害する行為<br/>
        (2)	当社または第三者の名誉・信用を毀損または不当に差別もしくは誹謗中傷する行為<br/>
        (3)	当社または第三者の財産を侵害する行為、または侵害する恐れのある行為<br/>
        (4)	当社または第三者に経済的損害を与える行為<br/>
        (5)	当社または第三者に対する脅迫的な行為<br/>
        (6)	法令、裁判所の判決、決定もしくは命令、または法令上拘束力のある行政措置に違反する行為<br/>
        (7)	公の秩序または善良の風俗を害するおそれのある行為<br/>
        (8)	コンピューターウィルス、有害なプログラムを使用またはそれを誘発する行為<br/>
        (9)	本サービス用インフラ設備に対して過度な負担となるストレスをかける行為<br/>
        (10)	本サービス用の専用Webサイト、サーバーやシステム、セキュリティへの攻撃<br/>
        (11)	当社提供のインターフェース以外の方法で当社サービスにアクセスを試みる行為<br/>
        (12)	本サービスが予定している利用目的と異なる目的で本サービスを利用する行為<br/>
        (13)	方法を問わず､当社の定める使用範囲を超えて行う、本サービスを構成するアプリおよび/またはコンテンツの複製、送信、譲渡（利用者同士の売買も含みます）、貸与、翻訳、翻案、無断転載、二次使用、営利目的の使用、改変、逆アセンブル、逆コンパイル、リバースエンジニアリング等の行為<br/>
        (14)	ID等を用い、転売等により収益を上げるまたは上げようとする行為<br/>
        (15)	本サービス内容とは関係がない目的をもって、利用者を選定し、ID等を使用させる行為<br/>
        (16)	ID等および/または本件専用URLを利用者以外に開示または漏洩する行為<br/>
        (17)	当社の事前の承諾を得ることなく本サービス利用の事実を第三者に伝達・開示等する行為<br/>
        (18)	登録情報（第9条参照）に虚偽の情報を記載した場合<br/>
        (19)	法令または条例等に違反した場合<br/>
        (20)	上記の他、当社が不適切と判断する行為<br/><br/>
        2.	前項の禁止行為に該当するか否かの判断は、当社の合理的な判断をもって行うものとし、当社は判断基準について説明する義務を負いません。<br/><br/>
      </div>
    </div>

    <div class="agreement-colum">
      <div class="agreement-colum-title">第7条（登録情報の取扱い）</div>
      <div class="agreement-colum-text">
        登録情報の訂正または削除については、当社（
        <a href="mailto:cs-ptk@lion.co.jp?subject=【口腔機能アプリ】問合せ">cs-ptk@lion.co.jp</a>
        ）（平日：9:00～12:00／13:00～17:00、土日・祝日・年末年始は休ませていただきます）までご連絡ください。
      </div>
    </div>

    <div class="agreement-colum">
      <div class="agreement-colum-title">第8条（登録情報および来院者等情報の利用）</div>
      <div class="agreement-colum-text">
        1.	登録医療機関は、本サービスを利用するに当たり、以下の情報（以下、「登録情報」という）を提供するものとします。<br/>
        (1)	医療機関名<br/>
        (2)	院長名<br/>
        (3)	メールアドレス<br/>
        (4)	電話番号<br/><br/>
        2.	登録情報および登録医療機関が、本サービスを利用する過程において当社が知り得た情報（本サービスの利用状況、当社製品の販売価格情報、利用者が来院者等に紹介した当社製品についての情報を含むがこれに限られない。）について、当社は、以下の各号の目的のために利用します。また、当社はこれらの情報をライオン歯科材株式会社、公益財団法人ライオン歯科衛生研究所に提供し、これらの法人において同様の目的のために利用します。<br/>
        (1)	登録医療機関の登録手続のため認証<br/>
        (2)	登録医療機関からの問い合わせ対応のため<br/>
        (3)	登録医療機関への個別連絡のため<br/>
        (4)	登録医療機関へのメールマガジンの配信のため<br/>
        (5)	アンケート・調査などによる情報収集のため<br/>
        (6)	製品情報及びサービス情報の収集・提供のため<br/>
        (7)	その他、上記各利用目的に準ずるか、これらに密接に関連する業務のため<br/><br/>
        3.	前項に定める情報の利用目的の達成に必要であると当社が判断した場合、当社（ライオン歯科材株式会社および公益財団法人ライオン歯科衛生研究所を含む）は、業務委託先に前項の情報を開示する場合があります。<br/><br/>
        4.	当社が、本条第2項記載の情報について、同項各号に記載する目的以外の目的で利用する必要が生じた場合には、新たな利用目的について事前に登録医療機関からご同意いただいた上で利用します。<br/><br/>
        5.	登録医療機関は、本サービスを利用する際は、各来院者等に対して以下の情報（以下、「来院者等情報」という）を入力させるものとします。なお、登録医療機関は、当社が、登録医療機関から来院者等情報を、本条7項に記載した利用目的のために取得しこれを利用することについて、各来院者等から事前に同意を取得しなければならないものとします。<br/>
        (1) 来院者等の性別<br/>
        (2) 来院者等の年齢<br/>
        (3) 来院者等の口腔状態（オーラルフレイルチェック結果）<br/>
        (4) オーラルディアドコキネシス測定の日時、各項目の結果数値<br/>
        (5) 評価結果レポート<br/>
        (6) 音声データ<br/><br/>
        6.	当社は、来院者等が本サービスを利用する都度、登録医療機関から来院者等情報を取得します。<br/><br/>
        7.	当社は、以下の各号の利用目的の範囲内で、取得した来院者等情報を利用します。<br/><br/>
        (1)	本サービスにおいて提供する全てのサービスの向上のため<br/>
        (2)	口腔分析・口腔科学研究および健康科学研究のため<br/>
        (3)	商品開発・サービス開発のため<br/><br/>
        8.	当社は来院者等情報をライオン歯科材株式会社、公益財団法人ライオン歯科衛生研究所に提供し、これらの法人において本条第7項の目的のために利用します。<br/><br/>
        9.	前項の場合、来院者等から個別に同意を取得した場合、または来院者等情報が統計化された場合を除き、第三者に来院者等情報が提供または公開されることはありません。<br/><br/>
        10.	当社は登録情報、本条2項の情報および来院者情報等に個人情報が含まれる場合は、ライオングループの「<a href="https://www.lion.co.jp/ja/legal/privacy/protect.php" target="_blank">個人情報の取り扱いについて</a>」に従って適切に管理します<br/><br/>
      </div>
    </div>

    <div class="agreement-colum">
      <div class="agreement-colum-title">第9条（本サービスの運営）</div>
      <div class="agreement-colum-text">
        1.	当社が登録医療機関による本サービス利用に関する記録を行うことを、登録医療機関には、あらかじめ承諾していただきます。なお、当社に必要が生じた場合、当社は何等の通知を行うことなくその内容の確認、削除等の必要な措置を行うことができるものとします。<br/><br/>
        2.	当社が独自の裁量に基づく判断により、登録医療機関または利用者がウェブサイト・ソーシャルメディア利用規約 第2条1項で禁止している事項に該当するか、または該当するおそれがあると認めたときには、任意に本サービスの提供を中止し、該当する情報又はファイル、その記録物および出力結果を消去、その他の方法により処分すること、並びに関係当局の求めに応じてこれを提出すること（複製の提出を含む）を、利用者はあらかじめ認めるものとします。利用者は、かかる処分に対して一切異議を申立てず、また、かかる処分に関連して当社が第三者からクレームを受けたときは、ウェブサイト・ソーシャルメディア利用規約 第2条2項に従うものとします。<br/><br/>
      </div>
    </div>

    <div class="agreement-colum">
      <div class="agreement-colum-title">第10条（本サービスの変更・中断・中止）</div>
      <div class="agreement-colum-text">
        1.	当社は、以下の事項に該当する場合、利用者に事前に通知することなく、本サービスの全部または一部の運営を変更、中断・中止できるものとします。<br/>
        (1)	本サービスのシステムの保守を定期的又は緊急に行う場合<br/>
        (2)	戦争、暴動、騒乱、労働争議、地震、噴火、洪水、津波、火災、停電その他の非常事態により、本サービスでコンテンツの提供ができなくなった場合<br/>
        (3)	本サービスにかかるシステムの障害<br/>
        (4)	電気通信インフラの障害による提供不能<br/>
        (5)	その他、当社が本サービスの一時中断が必要と判断した場合<br/><br/>
        2.	当社は、本サービスの運営を中止する時は、あらかじめその旨を利用者に通知するものとします。<br/><br/>
        3.	当社は、本条第1項により本サービスを変更、中断および中止した場合、利用者又は第三者が被ったいかなる損害についても、理由を問わず一切の責任を負わないものとします。<br/><br/>
      </div>
    </div>

    <div class="agreement-colum">
      <div class="agreement-colum-title">第11条（登録削除手続き）</div>
      <div class="agreement-colum-text">
        登録医療機関は、本サービスの利用終了を希望する場合、当社が定める方法により登録削除手続きを行い、本サービスの利用を終了することができます。
      </div>
    </div>

    <div class="agreement-colum">
      <div class="agreement-colum-title">第12条（情報の破棄）</div>
      <div class="agreement-colum-text">
        当社は、本サービスが終了した場合および利用者による本サービス最終ログインから3か月経過した場合は、情報等の一切を破棄、消去することができるものとし、当該情報が本サービスに関するシステム等に常に保存されていることについて保証しないものとします。本条の措置により利用者に損害が生じた場合でも、当社は一切の責任を負わないものとします。
      </div>
    </div>

    <div class="agreement-colum">
      <div class="agreement-colum-title">第13条（知的財産権）</div>
      <div class="agreement-colum-text">
        1.	本サービスを構成する著作物（文章、画像、プログラムその他一切の情報を含みます。）等の知的財産権は、利用者自身が作成したものを除き、当社または当社にその使用を許諾した第三者に帰属するものとします。<br/><br/>
        2.	登録医療機関および利用者は、本サービスに登録期間中に限り本サービスの利用を許諾されるものであり、当該期間中および期間終了後を通じ、本サービス上で提供される一切のデータ、資料及び情報等について、知的財産権が譲渡されるものではないことを承諾するものとします。<br/><br/>
      </div>
    </div>

    <div class="agreement-colum">
      <div class="agreement-colum-title">第14条（免責および損害賠償）</div>
      <div class="agreement-colum-text">
        1.	当社は、本サービスが登録医療機関の特定の目的に適合すること、期待する機能・商品的価値・正確性・有用性を有すること、登録医療機関による本サービスの利用が登録医療機関に適用のある法令または業界団体の内部規則等に適合すること、および不具合が生じないことについて、何ら保証するものではありません。<br/><br/>
        2.	本サービスは、登録医療機関の売上や来院者数等の向上を保証するものではありません。<br/><br/>
        3.	当社は、本サービスを利用することによる利用者の症状の改善および予防等につき何ら保証を行うものではありません。本サービスは特定の治療法・医学的見解を支持・推奨するものではなく、また診察行為や治療行為を目的としたものでもありません。登録医療機関はこれらを十分に認識頂いた上で、登録医療機関自身の責任において本サービスを利用するものとします。なお、具体的な治療行為等については、必ず、登録医療機関自身の責任において専門家の指導や診察を利用者に受けさせるものとし、当社は一切の責任を負いません。<br/><br/>
        4.	登録医療機関または利用者の入力したデータ、登録情報、来院者等情報の誤り、取り扱い、漏えい、滅失または毀損等に起因して、登録医療機関または利用者に損害が生じ、または第三者との間で紛争が生じた場合でも、当社は一切の責任を負いません。<br/><br/>
        5.	登録医療機関および利用者のアカウントの不適切な管理により生ずる情報・データ等の漏洩については、当社は一切の責任を負いません。<br/><br/>
        6.	当社は、本サービスの終了、本サービスの利用に伴うデータの消失または関連機器の故障若しくは損傷、その他本サービスに関連して登録医療機関または利用者が被った損害について、何ら責任を負わないものとします。<br/><br/>
        7.	登録医療機関および利用者が本サービスを利用するために使用するインターネット接続設備、および接続回線に問題が生じたとしても、当社は一切の責任を負いません。<br/><br/>
        8.	本サービスは、当社が定める動作保証環境に適した形で提供されるものとし、当社は、当社が推奨する動作保証環境以外の環境からの本サービスの利用について、一切動作保証を行いません。<br/><br/>
        9.	本条第４項から前項の規定に関して、当社に故意または重過失が存する場合には適用されません。<br/><br/>
        10.	いかなる場合であっても、当社が賠償の責を負うのは登録医療機関または利用者に生じた直接かつ通常の損害に限り、逸失利益、事業機会の喪失等の間接的な損害や特別な事情から生じた損害については、当社は一切の責任を負わないものとします 。<br/><br/>
        11.	登録医療機関または利用者と来院者等その他の第三者との間の紛争およびトラブルについて、当社は一切責任を負わないものとします。自己の費用と責任において、かかる損害を賠償またはかかる紛争を解決するものとし、当社には一切の迷惑や損害を与えないものとします。<br/><br/>
        12.	登録医療機関または利用者の行為に起因または関連して、第三者から当社が損害賠償等の請求をされた場合には、登録医療機関の費用（弁護士費用を含む）と責任で、これを解決するものとします。当社が、当該第三者に対して、損害賠償金を支払った場合には、登録医療機関は、当社に対して当該損害賠償金を含む一切の費用（弁護士費用および逸失利益を含む）を支払うものとします。<br/><br/>
        13.	登録医療機関および利用者が本サービスの利用に関連して当社に損害を与えた場合、登録医療機関の費用と責任において当社に対して損害を賠償（訴訟費用および弁護士費用を含む）するものとします。<br/><br/>
      </div>
    </div>

    <div class="agreement-colum">
      <div class="agreement-colum-title">第15条（通知・報告事項）</div>
      <div class="agreement-colum-text">
        登録医療機関に次の各号に該当する事由が生じたときは、登録医療機関は、直ちにその旨を当社に通知します。<br/>
        (1)	住所を移転したとき。<br/>
        (2)	商号を変更したとき。<br/>
        (3)	事業内容に重要な変更を生じたとき。<br/>
      </div>
    </div>

    <div class="agreement-colum">
      <div class="agreement-colum-title">第16条（準拠法および管轄裁判所について）</div>
      <div class="agreement-colum-text">
        1.	本規約の有効性、解釈および履行については、日本法に準拠し、日本法に従って解釈されるものとします。<br/><br/>
        2.	本規約または本サービスに起因し、または関連する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。<br/>
      </div>
    </div>

    <div class="agreement-colum">
      <div class="agreement-colum-title">第17条（雑則）</div>
      <div class="agreement-colum-text">
        本規約に定めのない事項または各条項の解釈等に疑義が生じた事項については、登録医療機関および当社が誠意をもって協議し、解決するものとします。<br/><br/>
      </div>
    </div>

    <br/>
    <br/>

    <div class="agreement-enactment">
      2025年5月制定
    </div>

      <div class="flex justify-content-center mt-56">
      <div class="btn-base-agreement" @click="closeClick">{{ $t('tos.close') }}</div>
    </div>
    <br/>

  </div>
</template>
<script>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';

export default {
  setup() {
    const router = useRouter();

    onMounted(() => {
      window.scrollTo(0, 0); // ページを一番上にスクロール
    });

    const closeClick = async() => {
      // ログイン画面へ遷移
      await router.push({
        name: 'login',
      });
    };

    return {
      closeClick,
    };
  },
};
</script>
<style lang="scss" scoped>
@import '@/scss/style.scss';

</style>